// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3yGIN","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__NInLS"};